import omit from 'lodash/omit';
import type {
	IssueType,
	RequestType,
} from '@atlassian/jira-issue-create-common-types/src/common/types/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type { InProgressIssue } from '../../common/types.tsx';
import type { InProgressIssueControllerState } from './types.tsx';

/**
 * State needs to be parsed before storing in indexed-db
 * @param triggerIssueCreateModalState
 * @returns
 */
export function convertStateToInProgressIssueForStorage(
	state: InProgressIssueControllerState,
): InProgressIssue {
	try {
		return {
			// removing these since they are only in InProgressIssueControllerState not InProgressIssue
			...omit(state, ['isInitialised', 'isSavingCounter']),
			// We need to do this to remove fields that are functions etc that we can't store in indexed-db
			formContext: state?.formContext ? JSON.parse(JSON.stringify(state.formContext)) : undefined,
			...(fg('fix-gryf-a11y-issues')
				? {
						triggerIssueCreateModalState: state?.triggerIssueCreateModalState
							? JSON.parse(
									JSON.stringify({ ...state.triggerIssueCreateModalState, triggerButtonRef: null }),
								)
							: undefined,
					}
				: {
						triggerIssueCreateModalState: state?.triggerIssueCreateModalState
							? JSON.parse(JSON.stringify(state.triggerIssueCreateModalState))
							: undefined,
					}),
		};
	} catch {
		return state;
	}
}

export function isRequestType(type: IssueType | RequestType | null): type is RequestType {
	if (!type) return false;
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	return (type as RequestType).issueTypeId !== undefined;
}
